import { Box, Icon, Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import {
  BankingEntitiesCardPaymentCalculatedLabelEnum,
  BankingEntitiesCardPaymentRejectedReasonEnum,
} from 'generated/resources/graphql'

import { rejectedReasonText } from 'modules/banking/lib/cardPayments/rejectedReasonText'
import { statusTagColor } from 'modules/banking/lib/cardPayments/statusTagColor'
import { statusText } from 'modules/banking/lib/cardPayments/statusText'

type CardPaymentWithInternalStatus = {
  calculatedLabel: BankingEntitiesCardPaymentCalculatedLabelEnum
  rejectedReason: BankingEntitiesCardPaymentRejectedReasonEnum | null | undefined
}

export const CardPaymentStatusTag: React.FC<{ cardPayment: CardPaymentWithInternalStatus }> = ({
  cardPayment,
}) => {
  const color = statusTagColor(cardPayment.calculatedLabel)
  const text = statusText(cardPayment.calculatedLabel)

  const RejectedReasonTooltip = ({
    reason,
  }: {
    reason: BankingEntitiesCardPaymentRejectedReasonEnum | null
  }) => {
    const [open, toggle] = useToggle(false)

    return (
      <Tooltip.Alt
        attachment="bottom center"
        open={open}
        toggle={toggle}
        label={rejectedReasonText(reason)}
      >
        <Icon.Medium icon="info-circle-line" color="iconSecondary" />
      </Tooltip.Alt>
    )
  }

  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <Box flexDirection="row" alignItems="center" gap="s6" width="s140">
        <Tag type={color} leftItem="circle" showCircle>
          {text}
        </Tag>
        {cardPayment.rejectedReason && (
          <RejectedReasonTooltip reason={cardPayment.rejectedReason} />
        )}
      </Box>
    </Box>
  )
}
